module.exports = __webpack_public_path__ + "img/platinum_villa_inner_1.079eb5ba.jpg";